import { sign, unsign } from './jwt.ts';
import type { State } from '../state/types/state.ts';
import type { GatewayRequest } from '../state/types/pending-requests.ts';

export function forRequest(state: State, impersonateIdentity: unknown, gwRequest: GatewayRequest, expMs?: number): string {
    const payload = {type: 'gw-request', 'impersonate-peer': impersonateIdentity, 'gw-request': gwRequest};
    if (expMs) {
        payload['exp'] = Math.floor(expMs / 1000);
    }
    return sign(payload, state.signatureKey);
}

export function forAuthentication(state: State, impersonateIdentity: {user: string}, expMs?: number): string {
    const payload = {type: 'authentication', user: impersonateIdentity.user}
    if (expMs) {
        payload['exp'] = Math.floor(expMs / 1000);
    }
    return sign(payload, state.signatureKey);
}

export function convertToken(signatureKey: string, token: string, expMs?: number): Record<string, unknown> {
    if (expMs === undefined) {
        expMs = expMs ?? Date.now()
    }
    const opts: {now?: number} = {};
    if (expMs) {
        opts.now = Math.floor(expMs / 1000);
    }
    return unsign(token, signatureKey, opts);
}
